import { Controller } from "@hotwired/stimulus"

import { playWithSound } from "../lib/video_slide"

// `#play` on a post page (full phase 093, decision 11): the address a post
// card's video links to, reached without the card's lightbox — no JavaScript
// on the list, a new tab. The post page plays its lead video
// (`[data-public-video]`, muted when the browser refuses sound, which it does
// without a press), or, with no lead video, opens the strip's first video
// slide through the `gallery` controller beside it. The fragment is never
// sent to the server, so the cached page and its canonical are unchanged.
export default class AutoplayController extends Controller<HTMLElement> {
  connect(): void {
    if (window.location.hash !== "#play") return

    // After the `gallery` controller of the same element has bound its links.
    requestAnimationFrame(() => {
      const video = this.element.querySelector<HTMLVideoElement>("video[data-public-video]")
      if (video) {
        void playWithSound(video)
        return
      }
      this.element.querySelector<HTMLAnchorElement>("a[data-pswp-type='video']")?.click()
    })
  }
}
